import { z } from "zod";

import {
  ConditionDefinitionIdSchema,
  DefinitionVersionSchema,
  EffectDefinitionIdSchema,
  MandateIdSchema,
  SCHEMA_VERSION,
  TriggerDefinitionIdSchema,
} from "./primitives.js";

const RulesTextSchema = z.string().trim().min(1).max(4000);

export const EffectReferenceSchema = z
  .object({
    effectId: EffectDefinitionIdSchema,
  })
  .strict();

export const ConditionReferenceSchema = z
  .object({
    conditionId: ConditionDefinitionIdSchema,
  })
  .strict();

export const TriggerReferenceSchema = z
  .object({
    triggerId: TriggerDefinitionIdSchema,
  })
  .strict();

export const EffectDefinitionSchema = z
  .object({
    schemaVersion: z.literal(SCHEMA_VERSION),
    definitionVersion: DefinitionVersionSchema,
    id: EffectDefinitionIdSchema,
    rulesText: RulesTextSchema,
  })
  .strict();

export const ConditionDefinitionSchema = z
  .object({
    schemaVersion: z.literal(SCHEMA_VERSION),
    definitionVersion: DefinitionVersionSchema,
    id: ConditionDefinitionIdSchema,
    rulesText: RulesTextSchema,
  })
  .strict();

export const TriggerDefinitionSchema = z
  .object({
    schemaVersion: z.literal(SCHEMA_VERSION),
    definitionVersion: DefinitionVersionSchema,
    id: TriggerDefinitionIdSchema,
    rulesText: RulesTextSchema,
  })
  .strict();

export const MandateReferenceSchema = z
  .object({
    mandateId: MandateIdSchema,
    name: z.string().trim().min(1).max(120),
    condition: ConditionReferenceSchema,
    effects: z.array(EffectReferenceSchema).min(1),
  })
  .strict();

export type ConditionDefinition = z.infer<typeof ConditionDefinitionSchema>;
export type ConditionReference = z.infer<typeof ConditionReferenceSchema>;
export type EffectDefinition = z.infer<typeof EffectDefinitionSchema>;
export type EffectReference = z.infer<typeof EffectReferenceSchema>;
export type MandateReference = z.infer<typeof MandateReferenceSchema>;
export type TriggerDefinition = z.infer<typeof TriggerDefinitionSchema>;
export type TriggerReference = z.infer<typeof TriggerReferenceSchema>;
